import { Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RentedToFieldComponent } from '../../forms/rented-to-field/rented-to-field.component';
import { RentalTypeFieldComponent } from '../../forms/rental-type-field/rental-type-field.component';
import { IncomeSourceFieldComponent } from '../../forms/income-source-field/income-source-field.component';
import { LivingSituationFieldComponent } from '../../forms/living-situation-field/living-situation-field.component';
import { BuildingStatusFieldComponent } from '../../forms/building-status-field/building-status-field.component';
import { BuildingPurposeFieldComponent } from '../../forms/building-purpose-field/building-purpose-field.component';
import { BuildingTypeFieldComponent } from '../../forms/building-type-field/building-type-field.component';
import { EnergyLabelFieldComponent } from '../../forms/energy-label-field/energy-label-field.component';
import { BooleanFieldComponent } from '../../forms/boolean-field/boolean-field.component';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { MatListItem } from '@angular/material/list';

@Component({
    selector: 'unite-list-item-select',
    templateUrl: './list-item-select.component.html',
    styleUrls: ['./list-item-select.component.scss'],
    imports: [MatListItem, NgClass, MatTooltip, BooleanFieldComponent, EnergyLabelFieldComponent, BuildingTypeFieldComponent, BuildingPurposeFieldComponent, BuildingStatusFieldComponent, LivingSituationFieldComponent, IncomeSourceFieldComponent, RentalTypeFieldComponent, RentedToFieldComponent]
})
export class ListItemSelectComponent {

  label = input<string>();
  control = input<FormControl>();
  type = input<string>();

  required = input(false);
  requiredNotNull = input(false);
  tooltip = input<string>();

  classItem = input('');

  editIcon = input(false);
  checkIcon = input(false);

  ownershipVerified = input(false);
  rentalType = input('');


  checkRequired() {
    if (this.required() !== false && (this.control().value == null || this.control().value === '' || this.control().value === 0)) {
      return true;
    } else if (this.requiredNotNull() !== false && this.control().value == null) {
      return true;
    } else {
      return false;
    }
  }

  checkValid() {
    return this.control() && this.control().touched && this.control().invalid;
  }

}
